class VideoModus extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector('button');
        this.video = this.querySelector('video');

        this.togglePlaying = this.togglePlaying.bind(this);

        if (this.button) {
            this.button.addEventListener('click', this.togglePlaying);
        }
    }

    togglePlaying() {
        const isVideoPlaying = () => !!(this.video && this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2);

        if (isVideoPlaying()) {
            this.video.pause();
            this.classList.remove('playing');
        } else {
            this.video.play();
            this.classList.add('playing');
        }
    }
}

customElements.define('video-modus', VideoModus);
